import { useState, useRef, useEffect, FC } from "react";
import S from "./index.module.scss";

interface ISelect {
  value?: string;
  setValue: (v: string) => void;
  label: string;
  items: { name: string; label: string }[];
}

const Select: FC<ISelect> = ({ value, setValue, label, items }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const selectedItem = items.find(i => i.name === value);

  return (
    <div className={S.selectWrapper} ref={rootRef}>
      <label className={S.label}>{label}</label>

      <div className={S.select} onClick={() => setOpen(o => !o)} data-open={open}>
        <span>{selectedItem ? selectedItem.label : "Выберите из списка"}</span>
        <span className={S.arrow}>▾</span>
      </div>

      {open && (
        <div className={S.dropdown}>
          {items.map(item => (
            <div
              key={item.name}
              className={`${S.option} ${item.name === value ? S.active : ""}`}
              onClick={() => {
                setValue(item.name);
                setOpen(false);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Select;
